export default __webpack_public_path__ + "static/media/view-calendar-active.9f98c576.svg";